import { Filters, Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { findAllTeamMember, findAllTeamMemberVariables } from '__generatedTypes__/findAllTeamMember'
import { GET_LIST_TEAM_MEMBER } from 'queries/teamMember'

export function castParams({ page, take }: Params<Filters>): findAllTeamMemberVariables {
  return {
    params: {
      skip: (page - 1) * take,
      take,
    },
  }
}

export function useTeamMembers() {
  return useQueryWithParams<findAllTeamMember, findAllTeamMemberVariables, 'findAllTeamMember', 'items', 'count'>(
    GET_LIST_TEAM_MEMBER,
    'findAllTeamMember',
    'items',
    'count',
    castParams,
    undefined,
    {
      fetchPolicy: 'network-only',
    }
  )
}
